import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const MachinesPageContent = lazy(() => import("./MachinesPageContent"));

function MachinesPageInternal() {
    return (
        <DefaultPage>
            <MachinesPageContent />
        </DefaultPage>
    );
}

export const MachinesPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(MachinesPageInternal);
